import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { IconButton } from '@zola/zola-ui';
import cx from 'classnames';

import './ModalFullscreen.less';

class ModalFullscreen extends Component {
  renderHeaderLeft = () => {
    const { headerLeftContent } = this.props;

    if (!headerLeftContent) return null;

    return <div className="modal__fullscreen--header-left">{headerLeftContent}</div>;
  };

  renderTitle = () => {
    const { headerTitle } = this.props;

    if (!headerTitle) return null;

    if (typeof headerTitle === 'string') {
      return <h2 className="modal__fullscreen--title">{headerTitle}</h2>;
    }

    return headerTitle;
  };

  renderHeader = () => {
    const { onClose } = this.props;

    return (
      <div className="modal__fullscreen--header">
        {this.renderHeaderLeft()}
        {this.renderTitle()}
        <div className="modal__fullscreen--header-right">
          <IconButton
            iconClassName="zola-ui-icon-close"
            className="modal__fullscreen__button--close"
            btnStyle="tertiary"
            onClick={onClose}
          />
        </div>
      </div>
    );
  };

  renderContent = () => {
    const { children } = this.props;

    return <div className="modal__fullscreen--content">{children}</div>;
  };

  renderFooter = () => {
    const { footerContent } = this.props;

    if (!footerContent) return null;

    return <div className="modal__fullscreen--footer">{footerContent}</div>;
  };

  render() {
    const { className, portalContainer } = this.props;

    const component = (
      <div className={cx('modal__fullscreen--container', className)}>
        {this.renderHeader()}
        {this.renderContent()}
        {this.renderFooter()}
      </div>
    );

    if (portalContainer) {
      return ReactDOM.createPortal(component, portalContainer);
    }

    return component;
  }
}

ModalFullscreen.propTypes = {
  headerLeftContent: PropTypes.node,
  headerTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  className: PropTypes.string,
  onClose: PropTypes.func,
  footerContent: PropTypes.node,
  portalContainer: PropTypes.instanceOf(Element),
};

ModalFullscreen.defaultProps = {};

export default ModalFullscreen;



// WEBPACK FOOTER //
// ./src/components/common/zolaUI/ModalFullscreen/ModalFullscreen.jsx